import {useTranslation} from "react-i18next";
import {useState} from "react";
import {useSnackbar, ButtonBar} from "@dain/mui-components";
import {useMutation} from "@tanstack/react-query";
import {Stack, Typography} from "@mui/material";
import {useClientLocator} from "../../../client/ApiClientLocator";
import {SubmissionTranslKey} from "../SubmissionTranslKey";
import {CommonTranslKey} from "../../../common/CommonTranslKey";
import Page from "../../../common/page/Page";
import Button from "../../../common/button/Button";

export function DigitalActionAuthorizationStartupOutageMockPage() {
    const {t} = useTranslation();
    const snackbar = useSnackbar();
    const {submissionAuthorizationClient} = useClientLocator();

    const [simulating, setSimulating] = useState(false);

    const mutation = useMutation({
        mutationFn: (simulate: boolean) => submissionAuthorizationClient.simulateDigitalActionAuthorizationStartupOutage(simulate),
        onSuccess: (_data, simulate) => setSimulating(simulate),
        onError: (err) => snackbar.error(t(CommonTranslKey.UNEXPECTED_ERROR), err),
    });

    return (
        <Page title={t(SubmissionTranslKey.SIMULATE_AUTHORIZATION_STARTUP_OUTAGE)}>
            <Stack direction={"column"} spacing={2} padding={1}>
                <Typography variant={"body2"}>{t(SubmissionTranslKey.SIMULATE_AUTHORIZATION_STARTUP_OUTAGE_DESCRIPTION)}</Typography>
                {simulating &&
                    <Typography variant={"body2"} color={"error"}>{t(SubmissionTranslKey.SIMULATE_AUTHORIZATION_STARTUP_OUTAGE_ACTIVE_HINT)}</Typography>
                }
                <ButtonBar>
                    {/* This page has no way to read back the current server-side toggle state (no GET
                        endpoint) - both buttons stay enabled so a tester can always force either state,
                        instead of trusting the locally-tracked `simulating` flag, which desyncs on reload
                        or navigation away without explicitly disabling the simulation first. */}
                    <Button variant={"primary"}
                            inProgress={mutation.isPending && mutation.variables === true}
                            onClick={() => mutation.mutate(true)}>
                        {t(SubmissionTranslKey.SIMULATE_AUTHORIZATION_STARTUP_OUTAGE_ENABLE)}
                    </Button>
                    <Button variant={"secondary"}
                            inProgress={mutation.isPending && mutation.variables === false}
                            onClick={() => mutation.mutate(false)}>
                        {t(SubmissionTranslKey.SIMULATE_AUTHORIZATION_STARTUP_OUTAGE_DISABLE)}
                    </Button>
                </ButtonBar>
            </Stack>
        </Page>
    );
}
